import { AxiosResponse } from "axios";

import { SignedUrlMetadata } from "../pages/VehicleAnalysis/types";
import client from "./client";

interface CreateSignedUrlResponse extends AxiosResponse {
  data: SignedUrlMetadata;
}
export const createSignedUrl = (sessionId: string, clientId: string): Promise<CreateSignedUrlResponse> =>
  client.post(`/client/${clientId}/session/${sessionId}/signedUrl`, {}, { headers: { session_id: sessionId } });
